import React from 'react';
import { Typography, styled, Button, Box, Link } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { toEuroWholeNumber } from '../../utils/numberFormat';
import { CashbackAdvantage } from '../DetailCalculator';

const FlexRow = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: theme.spacing(3),
}));

const BookNowButton = styled(Button)(({ theme }) => ({
  color: theme.palette.common.white,
  marginTop: theme.spacing(1),
  borderRadius: '6px',
  textTransform: 'none',
  fontWeight: 500,
}));

const BackButton = styled(Link)(({ theme }) => ({
  textDecoration: 'none',
  cursor: 'pointer',
  color: theme.palette.text.primary,

  '&:hover': {
    color: theme.palette.text.primary,
    textDecoration: 'underline',
  },
}));

interface Props {
  bookNowUrl: string;
  cashbackAdvantage: CashbackAdvantage;
  handleBackButtonClick: () => void;
}

export const CashbackAdvantageBox = ({
  cashbackAdvantage,
  handleBackButtonClick,
  bookNowUrl,
}: Props) => {
  const { t } = useTranslation();

  return (
    <Box flexGrow="1">
      <FlexRow>
        <Typography variant="body1" component="div" color="textSecondary">
          {t('cashbackCalculator.detailed.advantageBox.yourCashback')}
          &nbsp;&nbsp;
        </Typography>
        <Typography sx={{ fontSize: '28px', lineHeight: '34px' }} color="success.dark">
          {toEuroWholeNumber(cashbackAdvantage.cashback)}
        </Typography>
      </FlexRow>

      <FlexRow>
        <Typography variant="body1" component="div" color="textSecondary">
          {t('cashbackCalculator.detailed.advantageBox.yourAgioDiscount')}
          &nbsp;&nbsp;
        </Typography>
        <Typography sx={{ fontSize: '28px', lineHeight: '34px' }} color="success.dark">
          {toEuroWholeNumber(cashbackAdvantage.totalAgio)}
        </Typography>
      </FlexRow>

      <FlexRow>
        <Typography variant="body1" component="div" color="textSecondary">
          {t('cashbackCalculator.detailed.advantageBox.rentabloAdvantage')}
          &nbsp;&nbsp;
        </Typography>
        <Typography sx={{ fontSize: '28px', lineHeight: '34px' }} color="success.dark">
          {toEuroWholeNumber(cashbackAdvantage.cashback + cashbackAdvantage.totalAgio)}
        </Typography>
      </FlexRow>

      <FlexRow>
        <BookNowButton
          color="primary"
          variant="contained"
          size="large"
          fullWidth
          href={bookNowUrl}
          data-eventid="book-cashback-button"
        >
          {t('cashbackCalculator.detailed.advantageBox.applyButton')}
        </BookNowButton>
      </FlexRow>

      <FlexRow sx={{ justifyContent: 'center' }}>
        <BackButton>
          <Typography
            variant="body1"
            onClick={() => {
              handleBackButtonClick();
            }}
          >
            {`${t('cashbackCalculator.navigation.previous')}`}
          </Typography>
        </BackButton>
      </FlexRow>
    </Box>
  );
};
